import Vue from 'vue';
import Router from 'vue-router';
// 首页
const Home = () => import('../pages/home.vue');
// 登录页
const Login = () => import('../pages/login.vue');
// 数据模块
const Data = () => import('../pages/data/data.vue');
const DataNew = () => import('../pages/data/dataNew.vue');
const DataLogDb = () => import('../pages/data/dataLogDb.vue');
const DataLogDbMoon = () => import('../pages/data/dataLogDbMoon.vue');
const DataLogGtw = () => import('../pages/data/dataLogGtw.vue');
const DataLogDev = () => import('../pages/data/dataLogDev.vue');
const DataLogCz = () => import('../pages/data/dataLogCz.vue');
const DataTmp = () => import('../pages/data/dataTmp.vue');
// 管理模块
const GlDb = () => import('../pages/gl/glDb.vue');
const GlFml = () => import('../pages/gl/glFml.vue');
const GlGtw = () => import('../pages/gl/glGtw.vue');
const GlDvc = () => import('../pages/gl/glDvc.vue');
const GlFmlCeng = () => import('../pages/gl/glFmlCeng.vue');
const GlDvcFind = () => import('../pages/gl/glDvcFind.vue');
const GlUsr = () => import('../pages/gl/glUsr.vue');
const GlArea = () => import('../pages/gl/glArea.vue');
const GlDbWat = () => import('../pages/gl/glDbWat.vue');
// 数据操作模块
const DataSjLock = () => import('../pages/sj/dataSjLock.vue');
const DataSjTiming = () => import('../pages/sj/dataSjTiming.vue');
const DataSjTime = () => import('../pages/sj/dataSjTime.vue');
const DataSjOne = () => import('../pages/sj/dataSjOne.vue');
const DataSjGtw = () => import('../pages/sj/dataSjGtw.vue');
const DataSjPswd = () => import('../pages/sj/dataSjPswd.vue');
const DataSjMm = () => import('../pages/sj/dataSjMm.vue');
const DataSjHw = () => import('../pages/sj/dataSjHw.vue');
// 电量模块
const DlSjXs = () => import('../pages/dl/dlSjXs.vue');
const DlDj = () => import('../pages/dl/dlDj.vue');
const DlSum = () => import('../pages/dl/dlSum.vue');
const DlSumLog = () => import('../pages/dl/dlSumLog.vue');
const DlSumLog1 = () => import('../pages/dl/dlSumLog1.vue');
const DlSumLog2 = () => import('../pages/dl/dlSumLog2.vue');
const DlGs = () => import('../pages/dl/dlGs.vue');
const DlGs1 = () => import('../pages/dl/dlGs.vue');
const DlStop = () => import('../pages/dl/dlStop.vue');
const DlDjSon = () => import('../pages/dl/dlDjSon.vue');
const DlSumTab = () => import('../pages/dl/dlSumTab.vue');
const DlDjSon1 = () => import('../pages/dl/dlDjSon1.vue');
const DlTabDay = () => import('../pages/dl/dlTabDay.vue');
const DlTabMoon = () => import('../pages/dl/dlTabMoon.vue');
const DlLimit = () => import('../pages/dl/dlLimit.vue');
// 场景模块
const SceneCtrTab = () => import('../pages/scene/sceneCtrTab.vue');
const SceneCtrTabShow = () => import('../pages/scene/sceneCtrTabShow.vue');
const SceneCtrTabTime = () => import('../pages/scene/sceneCtrTabTime.vue');
const SceneTiming = () => import('../pages/scene/sceneTiming.vue');
const Scenes = () => import('../pages/scene/scenes.vue');
const SceneSon = () => import('../pages/scene/sceneSon.vue');
const SceneLink = () => import('../pages/scene/sceneLink.vue');
// 控制模块
const CtrSensor = () => import('../pages/ctrol/ctrSensor.vue');
const CtrKtMain = () => import('../pages/ctrol/ctrKtMain.vue');
const CtrKt = () => import('../pages/ctrol/ctrKt.vue');
const ctrGroup = () => import('../pages/ctrol/ctrGroup.vue');
const CtrKtMany = () => import('../pages/ctrol/ctrKtMany.vue');
const CtrPwrMk = () => import('../pages/ctrol/ctrPwrMk.vue');
const CtrWbDn = () => import('../pages/ctrol/ctrWbDn.vue');
const CtrLight = () => import('../pages/ctrol/ctrLight.vue');
const CtrZfDev = () => import('../pages/ctrol/ctrZfDev.vue');
const aaaa = () => import('../pages/count/countTab.vue');
// 公共页面
const AShow = () => import('../pages/data/aShow.vue');
// ====================== 2. 公共组件（静态导入，全局使用）======================
import ZDDC from '../components/zDDC.vue';
import ADB from '../components/adb.vue';
import glArea from '../pages/gl/glArea.vue';
import ctrKt from '../pages/ctrol/ctrKt.vue';

Vue.use(Router);

export default new Router({ /*配置路由跳转页面*/
  /* history需要config/index.js下的 assetsPublicPath:'/'*/
  /* hash需要 assetsPublicPath:'./' */
  mode:'hash',routes:[
    {
      path:'/',name:'login',component:Login
    },
    {
      path:'/login',name:'login',component:Login
    },
    {
      path:'/home',  /*配置子页面时需要隐藏 name:'home'*/
      component:Home,children:[
        {path:'',name:'',component:ctrKt},
        {path:'aaaa',name:'aaaa',component:aaaa},
        {path:'adb',name:'adb',component:ADB},
        {path:'pageShow',name:'pageShow',component:AShow},
        {path:'areagl',name:'areagl',component:glArea},
        {path:'data',name:'data',component:Data},
        {path:'scenes',name:'scenes',component:Scenes},
        {path:'sceneSon',name:'sceneSon',component:SceneSon},
        {path:'sceneLink',name:'sceneLink',component:SceneLink},
        {path:'sceneTiming',name:'sceneTiming',component:SceneTiming},
        {path:'sceneCtrTab',name:'sceneCtrTab',component:SceneCtrTab},
        {path:'sceneCtrTabShow',name:'sceneCtrTabShow',component:SceneCtrTabShow},
        {path:'sceneCtrTabTime',name:'sceneCtrTabTime',component:SceneCtrTabTime},
        {path:'dlGs',name:'dlGs',component:DlGs},
        {path:'dlGs1',name:'dlGs1',component:DlGs1},
        {path:'dlSum',name:'dlSum',component:DlSum},
        {path:'dlSumTab',name:'dlSumTab',component:DlSumTab},
        {path:'dlTabDay',name:'dlTabDay',component:DlTabDay},
        {path:'dlTabMoon',name:'dlTabMoon',component:DlTabMoon},
        {path:'dlSumLog',name:'dlSumLog',component:DlSumLog},
        {path:'dlSumLog1',name:'dlSumLog1',component:DlSumLog1},
        {path:'dlSumLog2',name:'dlSumLog2',component:DlSumLog2},
        {path:'dataNew',name:'dataNew',component:DataNew},
        {path:'dataLogDev',name:'dataLogDev',component:DataLogDev},
        {path:'dataTmp',name:'dataTmp',component:DataTmp},
        {path:'dataSjOne',name:'dataSjOne',component:DataSjOne},
        {path:'dataSjGtw',name:'dataSjGtw',component:DataSjGtw},
        {path:'dataSjLock',name:'dataSjLock',component:DataSjLock},
        {path:'dataSjPswd',name:'dataSjPswd',component:DataSjPswd},
        {path:'dataSjMm',name:'dataSjMm',component:DataSjMm},
        {path:'dataSjHw',name:'dataSjHw',component:DataSjHw},
        {path:'dataSjTime',name:'dataSjTime',component:DataSjTime},
        {path:'dataSjTiming',name:'dataSjTiming',component:DataSjTiming},
        {path:'dataLogDb',name:'dataLogDb',component:DataLogDb},
        {path:'dataLogDbMoon',name:'dataLogDbMoon',component:DataLogDbMoon},
        {path:'glDb',name:'glDb',component:GlDb},
        {path:'glDbWat',name:'glDbWat',component:GlDbWat},
        {path:'glDvc',name:'glDvc',component:GlDvc},
        {path:'glDvcFind',name:'glDvcFind',component:GlDvcFind},
        {path:'glGtw',name:'glGtw',component:GlGtw},
        {path:'glArea',name:'glArea',component:GlArea},
        {path:'glFml',name:'glFml',component:GlFml},
        {path:'glFmlCeng',name:'glFmlCeng',component:GlFmlCeng},
        {path:'glUsr',name:'glUsr',component:GlUsr},
        {path:'dlSjXs',name:'dlSjXs',component:DlSjXs},
        {path:'dlDj',name:'dlDj',component:DlDj},
        {path:'dlDjSon',name:'dlDjSon',component:DlDjSon},
        {path:'dlDjSon1',name:'dlDjSon1',component:DlDjSon1},
        {path:'dlStop',name:'dlStop',component:DlStop},
        {path:'dlLimit',name:'dlLimit',component:DlLimit},
        {path:'dataLogGtw',name:'dataLogGtw',component:DataLogGtw},
        {path:'dataLogCz',name:'dataLogCz',component:DataLogCz},
        {path:'ctrKtMain',name:'ctrKtMain',component:CtrKtMain},
        {path:'ctrLight',name:'ctrLight',component:CtrLight},
        {path:'ctrZfDev',name:'ctrZfDev',component:CtrZfDev},
        {path:'ctrWbDn',name:'ctrWbDn',component:CtrWbDn},
        {path:'ctrPwrMk',name:'ctrPwrMk',component:CtrPwrMk},
        {path:'ctrSensor',name:'ctrSensor',component:CtrSensor},
        {path:'ctrKt',name:'ctrKt',component:ctrKt},
        {path:'ctrKtMany',name:'ctrKtMany',component:CtrKtMany},
        {path:'ctrGroup',name:'ctrGroup',component:ctrGroup},
        {path:'zDDC',name:'zDDC',component:ZDDC}
        /*{
         path: 'aLog',  /!*配置子页面时需要隐藏name*!/
         component: aLog, children: [
         {path: '', name: '', component: alogUser},
         {path: 'alogUser', name: 'alogUser', component: alogUser},
         {path: 'alogDev', name: 'alogDev', component: alogDev},
         {path: 'alogScene', name: 'alogScene', component: alogScene},
         {path: 'alogTiming', name: 'alogTiming', component: alogTiming},
         ],
         },*/
      ]
    }
  ]
});

/*隐藏Router报错警示*/
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this,location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js